import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LocationEditor from '@blade-sxp/monitor/components/image-editor/device-editor/index.vue';
let default_1 = class default_1 extends Vue {
    outerVisible;
    imgSrc;
    initCircles;
    dialogVisible = false;
    outerCircles = [];
    options = { radius: 45, drawCircleOption: { dashed: false, lineColor: ['#C7996F'], opacity: 1 } };
    currVal = '0';
    mode = 'EDIT';
    contentWidth = '75%';
    onChildChanged(val, oldVal) {
        this.dialogVisible = this.outerVisible;
        if (this.dialogVisible && this.imgSrc) {
            console.log('imgSrc:', this.imgSrc);
            this.outerCircles = this.initCircles;
            this.$nextTick(() => {
                this.getBase64Image();
            });
        }
    }
    onInitCirclesChange(val, oldVal) {
        this.outerCircles = this.initCircles;
    }
    handleClose() {
        this.$emit('on-close', false);
    }
    handleDrawCircles(circles) {
        const last = circles.pop();
        this.outerCircles = [last];
        const { vertex } = last;
    }
    getBase64Image() {
        const img = new Image();
        img.onload = () => {
            this.changeDom({ width: img.naturalWidth, height: img.naturalHeight });
        };
        img.src = this.imgSrc;
    }
    changeDom(item) {
        let ele = document.getElementById('editorId');
        if (item.height > item.width) {
            ele.style.width = `${(window.innerHeight * 0.73 * item.width) / item.height}px`;
            ele.style.height = `${window.innerHeight * 0.73}px`;
            this.contentWidth = `${(window.innerHeight * 0.73 * item.width) / item.height}px`;
        }
        else {
            ele.style.width = `${window.innerWidth * 0.73}px`;
            ele.style.height = `${(window.innerWidth * 0.73 * item.height) / item.width}px`;
            this.contentWidth = `${window.innerWidth * 0.73}px`;
        }
        this.$refs.editorRef.init();
    }
    handleResize(mode) {
        if (mode === 'IN') {
            this.currVal = Number(this.currVal) + 50 >= 100 ? '100' : `${Number(this.currVal) + 50}`;
        }
        else {
            this.currVal = Number(this.currVal) - 50 >= 0 ? `${Number(this.currVal) - 50}` : '0';
        }
    }
    handleDelete() {
        this.outerCircles = [];
    }
    handleClick() {
        console.log('confirm');
        if (this.outerCircles.length) {
            this.$emit('confirm', this.outerCircles);
        }
    }
};
__decorate([
    Prop({})
], default_1.prototype, "outerVisible", void 0);
__decorate([
    Prop({})
], default_1.prototype, "imgSrc", void 0);
__decorate([
    Prop({})
], default_1.prototype, "initCircles", void 0);
__decorate([
    Watch('outerVisible')
], default_1.prototype, "onChildChanged", null);
__decorate([
    Watch('initCircles')
], default_1.prototype, "onInitCirclesChange", null);
default_1 = __decorate([
    Component({
        name: 'Form',
        components: { LocationEditor },
        i18n: {
            messages: {
                'en-us': {
                    delete: 'Clear',
                    confirm: 'Save',
                    empty: 'No data',
                },
                zh: {
                    delete: '清空',
                    confirm: '保存',
                    empty: '无图',
                },
            },
        },
    })
], default_1);
export default default_1;
